module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "close-picker",
    attrs: {
      "id": "register-screen"
    },
    on: {
      "popup:open": function($event) {}
    }
  }, [_c('f7-navbar', [_c('f7-nav-center', {
    staticClass: "titleApp",
    attrs: {
      "sliding": ""
    }
  }, [_c('p', {
    staticClass: "logoHomepage"
  }, [_c('img', {
    staticClass: "loginLogo",
    attrs: {
      "src": require("./../../assets/static/images/logo/moneyroad_green.svg")
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "registerForm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 offset-md-3"
  }, [_c('div', {
    staticClass: "pilotageTabButtonContainer pilotageTabButtonContainerRegister"
  }, [_c('f7-grid', {
    attrs: {
      "no-gutter": ""
    }
  }, [_c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50"
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink",
    class: {
      tabActive: _vm.currentRole === 'individual'
    },
    attrs: {
      "tab-link": ".tabIndividual",
      "active": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('individual')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.indiv')))])], 1), _vm._v(" "), _c('f7-col', {
    staticClass: "pilotageTabController",
    attrs: {
      "width": "50",
      "disabled": ""
    }
  }, [_c('f7-link', {
    staticClass: "pilotageLink",
    class: {
      tabActive: _vm.currentRole === 'professional'
    },
    staticStyle: {
      "background": "#999",
      "color": "#fff !important"
    },
    attrs: {
      "tab-link": ".tabProfessional"
    },
    on: {
      "click": function($event) {
        return _vm.changeCurrentRole('professional')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.busnss')))])], 1)], 1)], 1), _vm._v(" "), _c('f7-tabs', [_c('f7-tab', {
    staticClass: "tabIndividual",
    attrs: {
      "active": "",
      "no-gutter": ""
    }
  }, [_c('div', {
    staticClass: "data-table card"
  }, [_c('f7-list', {
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "First Name",
      "placeholder": _vm.register_FirstName,
      "type": "text"
    },
    model: {
      value: (_vm.firstName_r),
      callback: function($$v) {
        _vm.firstName_r = $$v
      },
      expression: "firstName_r"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Last Name",
      "placeholder": _vm.register_LastName,
      "type": "text"
    },
    model: {
      value: (_vm.LastName_r),
      callback: function($$v) {
        _vm.LastName_r = $$v
      },
      expression: "LastName_r"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Email",
      "placeholder": _vm.register_Email,
      "type": "email"
    },
    model: {
      value: (_vm.email_r),
      callback: function($$v) {
        _vm.email_r = $$v
      },
      expression: "email_r"
    }
  })], 1), _vm._v(" "), _c('li', [_c('form-dropdown-input', {
    attrs: {
      "placeholderValue": _vm.$t('common.ctry'),
      "itemList": _vm.country
    },
    model: {
      value: (_vm.country_r),
      callback: function($$v) {
        _vm.country_r = $$v
      },
      expression: "country_r"
    }
  })], 1), _vm._v(" "), (_vm.displayPassword) ? _c('f7-list-item', {
    attrs: {
      "required": ""
    }
  }, [_c('f7-input', {
    attrs: {
      "name": "Password",
      "type": "password",
      "placeholder": _vm.register_Password,
      "autocomplete": "new-password"
    },
    model: {
      value: (_vm.password1_r),
      callback: function($$v) {
        _vm.password1_r = $$v
      },
      expression: "password1_r"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-eye_blind icon icon-password",
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayPassword) ? _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Repeat Password",
      "type": "password",
      "placeholder": _vm.register_RepeatPassword
    },
    model: {
      value: (_vm.password2_r),
      callback: function($$v) {
        _vm.password2_r = $$v
      },
      expression: "password2_r"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-eye_blind icon icon-password",
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('f7-tab', {
    staticClass: "tabProfessional"
  }, [_c('div', {
    staticClass: "data-table card"
  }, [_c('f7-list', {
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Company Name",
      "placeholder": _vm.register_CompanyName,
      "type": "text"
    },
    model: {
      value: (_vm.companyName_r),
      callback: function($$v) {
        _vm.companyName_r = $$v
      },
      expression: "companyName_r"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Company Number",
      "placeholder": _vm.register_CompanyNumber,
      "type": "text"
    },
    model: {
      value: (_vm.companyNumber_r),
      callback: function($$v) {
        _vm.companyNumber_r = $$v
      },
      expression: "companyNumber_r"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Email",
      "placeholder": _vm.register_Email,
      "type": "email"
    },
    model: {
      value: (_vm.email_r),
      callback: function($$v) {
        _vm.email_r = $$v
      },
      expression: "email_r"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title"
  }, [(this.country_r2 === '') ? _c('span', [_vm._v(_vm._s(_vm.$t('common.ctry')))]) : _c('span', [_vm._v(_vm._s(_vm.country_r2))])]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [_c('a', {
    staticClass: "link open-picker button button-round button-inner-color",
    attrs: {
      "href": "#",
      "data-picker": ".countryListPicker"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.slct')) + "\n                  ")])])])]), _vm._v(" "), (_vm.displayPassword) ? _c('f7-list-item', {
    attrs: {
      "required": ""
    }
  }, [_c('f7-input', {
    attrs: {
      "name": "Password",
      "type": "password",
      "placeholder": _vm.register_Password
    },
    model: {
      value: (_vm.password1_r),
      callback: function($$v) {
        _vm.password1_r = $$v
      },
      expression: "password1_r"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-eye_blind icon icon-password",
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayPassword) ? _c('f7-list-item', [_c('f7-input', {
    attrs: {
      "name": "Repeat Password",
      "type": "password",
      "placeholder": _vm.register_RepeatPassword
    },
    model: {
      value: (_vm.password2_r),
      callback: function($$v) {
        _vm.password2_r = $$v
      },
      expression: "password2_r"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-eye_blind icon icon-password",
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1) : _vm._e()], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row mr-0 ml-0"
  }, [_c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('button', {
    staticClass: "milkyBlock w-100 font-weight-bold mr-0 ml-0",
    staticStyle: {
      "box-shadow": "none",
      "border": "1px #12bcf1 solid",
      "color": "#12bcf1"
    },
    attrs: {
      "title": "Back to Login Page"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.bck')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-left": "0",
      "padding-right": "0"
    }
  }, [_c('button', {
    staticClass: "milkyBlock w-100 font-weight-bold mr-0 ml-0",
    staticStyle: {
      "box-shadow": "none",
      "border": "1px #12bcf1 solid",
      "color": "#12bcf1"
    },
    attrs: {
      "title": "Register New User"
    },
    on: {
      "click": function($event) {
        return _vm.registerNewUser()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.rgstr')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-modal countryListPicker"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "toolbar-inner"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('a', {
    staticClass: "close-picker orangeBackground",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.countryListPickerCloseButton
    }
  }, [_vm._v(_vm._s(_vm.$t('common.bck')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "picker-modal-inner scrollablePicker"
  }, [_c('f7-searchbar', {
    attrs: {
      "id": "searchCountry",
      "cancel-link": "Cancel",
      "search-list": ".countryList",
      "placeholder": "Search"
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-block countryList"
  }, [_c('f7-list', {
    staticClass: "countryList",
    attrs: {
      "contacts": ""
    }
  }, _vm._l((_vm.filteredCountries), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(country) {
      return _c('li', {
        attrs: {
          "value": country
        }
      }, [_c('label', {
        staticClass: "label-radio item-content",
        on: {
          "click": _vm.countryListPickerCloseButton
        }
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "name": "countryPickerRadio"
        },
        domProps: {
          "value": country
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(country))])])])])
    })], 2)
  }), 1)], 1)], 1)])], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12eb5ba4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12eb5ba4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CMRegister.vue
// module id = 1625
// module chunks = 2